import charts from '../charts.js';
import technicalsChart from './technicals.js';

export default function({ id, data, config, dates, defaults, earningsData }) {
	defaults = {
		defaultSeries: 'candlesticks',
		defaultOverlays: [],
		defaultIndicators: [],
		periodGrouping: 'daily',

		... defaults,
	}

	defaults.defaultIndicators.unshift('score');

	return technicalsChart({ id, data, config, dates, defaults, earningsData });
}
